"use strict"

function removeClass(class_name) {
  document.querySelectorAll(`.${class_name}`).forEach((tg)=>{
    tg.classList.remove(class_name);
  });
}

document.addEventListener('DOMContentLoaded', ()=>{
  document.querySelector('.adan-content-bg').addEventListener('mouseenter', (e)=>{e.preventDefault();e.stopPropagation();},true);
  document.querySelector('.adan-content-bg').addEventListener('mouseleave', (e)=>{e.preventDefault();e.stopPropagation();},true);
  var myAnimation = new hoverEffect({
        parent: document.querySelector('.adan-content-bg'),
        intensity: 0.35,
        // image1: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/bg09.png',
        // image1: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/parq.webp?v=1711074124',
        image1: 'https://cdn.shopify.com/s/files/1/0537/5616/6342/files/parq_fuk_355697592_1708203339693921_202970354728854363_n_waifu2x_photo_noise1_scale.webp?v=1725708155',
        // image2: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/adan.webp?v=1710815204',
        image2: 'https://cdn.shopify.com/s/files/1/0537/5616/6342/files/02.webp?v=1725708156',
        // image2: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/white_back01.webp?v=1710814492',
        // displacementImage: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/2.jpg'
        // displacementImage: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/1.jpg'
        // displacementImage: 'https://cdn.shopify.com/s/files/1/0649/1724/2045/files/7.jpg'
        displacementImage: 'https://cdn.shopify.com/s/files/1/0537/5616/6342/files/4.png?v=1725708153'
  });

  if(location.href.match('#note')) {
    document.querySelectorAll(`[data-content="note"]`).forEach((tg)=>{
      tg.classList.add('active-content');
    });
    document.querySelectorAll(`[data-menu="adan"]`).forEach((elm)=>{
      elm.classList.remove('active-menu');
    });
    document.querySelectorAll(`[data-content="adan"]`).forEach((elm)=>{
      elm.classList.remove('active-content');
    });
    document.querySelector(`[data-menu="note"]`).classList.add('active-menu');
    myAnimation.next();
  }
  
  const menu = document.querySelectorAll('.navigator-menu');
  menu.forEach((elm)=>{
    elm.addEventListener('click', ()=>{
      if(!elm.classList.contains('active-menu')) {
        removeClass('active-menu');
        removeClass('active-content');
        elm.classList.add('active-menu');
        document.querySelectorAll(`[data-content="${elm.dataset.menu}"]`).forEach((tg)=>{
          tg.classList.add('active-content');
        });
        if(elm.dataset.menu == 'note') {
          myAnimation.next();
        } else {
          myAnimation.previous();
        }
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      }
    });
  });

});